import React from 'react';
export const HtmlOutputContext = React.createContext({ data: undefined });
